<template>
	<div>
		<!-- ------------------------------註冊開始------------------------------ -->
        <div class="modal fade cm-modal" id="registerModal" tabindex="-1" role="dialog" aria-labelledby="registerModalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header text-center text-white cm-register-header">
                        <h4 class='col-12 modal-title text-center'>
                            {{$t('register.Title')}}
                            <button type="button" class="close cm-register-close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <img src="@/assets/images/login-close.png">
                                </span>
                            </button>
                        </h4>
                    </div>
                    <div class="modal-body px-md-5 cm-register-body">
                        <div class="form-group row">
                            <div class="col-md-6">
                                <input v-model="inputAccount" v-on:blur="accountInputMonitor"  name="register.account" id="inputAccount" type="text" class="form-control" maxlength="20" :placeholder='$t("register.Account")'>
                                <span class="text-danger" v-if="accountPromptString !== ''">{{accountPromptString}}</span>
                            </div>
                            <label for="inputAccount" class="col-md-6 col-form-label">{{$t('register.Input')}}</label>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-6">
                                <input v-model="inputPassword" v-on:blur="passwordInputMonitor" name="register.password" id="inputPassword" type="password" class="form-control" maxlength="20" :placeholder='$t("register.Password")'>
                                <span class="text-danger" v-if="passwordPromptString !== ''">{{passwordPromptString}}</span>
                            </div>
                            <label for="inputPassword" class="col-md-6 col-form-label">{{$t('register.Input')}}</label>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-6">
                                <input v-model="inputConfirmPassword" v-on:blur="confirmPasswordInputMonitor" name="register.confirmPassword" id="inputConfirmPassword" type="password" class="form-control" maxlength="20" :placeholder='$t("register.ConfirmPassword")'>
                                <span class="text-danger" v-if="confirmPasswordPromptString !== ''">{{confirmPasswordPromptString}}</span>
                            </div>
                            <label for="inputConfirmPassword" class="col-md-6 col-form-label">{{$t('register.ConfirmPassword')}}</label>
                        </div>
                        <div class="form-group row">
                            <div class="col-md-6">
                                <input v-model="inputEmail" v-on:blur="emailInputMonitor" name="register.email" id="inputConfirmEmail" type="email" class="form-control" :placeholder='$t("register.Email")'>
                                <span class="text-danger" v-if="emailPromptString !== ''">{{emailPromptString}}</span>
                            </div>
                            <label for="inputConfirmEmail" class="col-md-6 col-form-label">{{$t('register.Email')}}</label>
                        </div>
                        <span>※</span>
                        <span>{{$t('register.InfoSent.1')}}</span>
                        <br>
                        <span>※</span>
                        <span>{{$t('register.InfoSent.2')}}</span>
                        <hr>
                        <div class="form-check">
                            <input v-model="checkPrivacyPolicy" class="form-check-input" type="checkbox" id="checkmember" value="1">
                            <label class="form-check-label text-dark font-weight-bold">
                                {{$t('register.Accept')}}
                                <a href="#" @click="routerPolicy(routerTermsOfService)">
                                    {{$t('register.PrivacyPolicy.1')}}
                                </a>
                                {{$t('register.PrivacyPolicy.2')}}
                            </label>
                            <br />
                            <span class="text-danger" v-if="checkPrivacyPolicyPromptString !== ''">{{checkPrivacyPolicyPromptString}}</span>
                        </div>
                        <div class="form-check">
                            <input v-model="checkPersonalPolicy" class="form-check-input" type="checkbox" id="checkPersonalPolicy" value="1">
                            <label class="form-check-label text-dark font-weight-bold">
                                {{$t('register.Accept')}}
                                <a href="#" @click="routerPolicy(routerPrivacyPolicy)">
                                    {{$t('register.PersonalDataPolicy.1')}}
                                </a>
                                {{$t('register.PersonalDataPolicy.2')}}
                            </label>
                            <br />
                            <span class="text-danger" v-if="checkPersonalPolicyPromptString !== ''">{{checkPersonalPolicyPromptString}}</span>
                        </div>
                        <div class="col py-2 text-center">
                            <div v-if="domControl.isWaitingRegistratAll9fun==true" class="spinner-border text-warning text-center my-2" role="status"></div>
                            <button v-else @click="googleRecaptchaService" type="button" class="btn btn-lg text-white cm-register-send-button">{{$t('register.Confirm')}}</button>
                        </div>
                        <img src="@/assets/images/cmi_logo_black.png" class="cm-register-img">
                    </div>
                </div>
            </div>
        </div>
        <!-- ------------------------------註冊結束------------------------------ -->
	</div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'
import router from '@/router.js'
import Login from "@/components/modal/Login.vue";
import RecaptchaUtil from "@/assets/js/util/RecaptchaUtil.js";
import ValidatorUtil from '@/assets/js/util/ValidatorUtil.js'
import eventBus from '@/assets/js/event/EventBus.js'

export default {
    data() {
        return {
            inputAccount: "",
            accountPromptString: "",
            inputPassword: "",
            passwordPromptString: "",
            inputConfirmPassword: "",
            confirmPasswordPromptString: "",
            inputEmail: "",
            emailPromptString: "",
            checkPrivacyPolicy: [],
            checkPrivacyPolicyPromptString: "",
            checkPersonalPolicy: [],
            checkPersonalPolicyPromptString: "",
            googleRecaptchaWidget: null,
            routerTermsOfService: process.env.VUE_APP_ROUTER_TERMS_OF_SERVICE,
            routerPrivacyPolicy: process.env.VUE_APP_ROUTER_PRIVACY_POLICY,
            routerPersonalData: process.env.VUE_APP_ROUTER_PERSONAL_DATA,
            domControl: {
                isWaitingRegistratAll9fun: false
            },
        }
    },
    watch: {
        checkPrivacyPolicy: function() {
            this.checkPrivacyPolicyChecker();
        },
        checkPersonalPolicy: function() {
            this.checkPersonalPolicyChecker();
        }
    },
    methods: {
        routerPolicy(pushRouterName) {
            router.push({name: pushRouterName})
            $("#registerModal").modal('hide');
        },
        async accountInputMonitor() {
            // 驗證字串長度
            this.accountPromptString = ValidatorUtil.validLength(this.inputAccount, {
                'req': this.$i18n.t('register.Validate.Account.req'),
                'maxLen': this.$i18n.t('register.Validate.Account.maxLen'),
                'minLen': this.$i18n.t('register.Validate.Account.minLen')
            })
            if(ValidatorUtil.isLengthMeet(this.inputAccount)) {
                // 驗證字串為英數
                this.accountPromptString = ValidatorUtil.validEngNumOnly(this.inputAccount, {
                    'engNumOnly': this.$i18n.t('register.Validate.Account.engNumOnly')
                })
            }
        },
        passwordInputMonitor() {
            // 驗證字串長度
            this.passwordPromptString = ValidatorUtil.validLength(this.inputPassword, {
                'req': this.$i18n.t('register.Validate.Password.req'),
                'maxLen': this.$i18n.t('register.Validate.Password.maxLen'),
                'minLen': this.$i18n.t('register.Validate.Password.minLen')
            });
            if(ValidatorUtil.isLengthMeet(this.inputPassword)) {
                // 驗證字串為英數
                this.passwordPromptString = ValidatorUtil.validEngNumOnly(this.inputPassword, {
                    'engNumOnly': this.$i18n.t('register.Validate.Password.engNumOnly')
                })
            }
        },
        confirmPasswordInputMonitor() {
            // 驗證字串長度
            this.confirmPasswordPromptString = ValidatorUtil.validLength(this.inputConfirmPassword, {
                'req': this.$i18n.t('register.Validate.ConfirmPassword.req'),
                'maxLen': this.$i18n.t('register.Validate.ConfirmPassword.maxLen'),
                'minLen': this.$i18n.t('register.Validate.ConfirmPassword.minLen')
            });
            if(ValidatorUtil.isLengthMeet(this.inputConfirmPassword)) {
                // 驗證字串為英數
                this.confirmPasswordPromptString = ValidatorUtil.validEngNumOnly(this.inputConfirmPassword, {
                    'engNumOnly': this.$i18n.t('register.Validate.ConfirmPassword.engNumOnly')
                })
                if(this.confirmPasswordPromptString != "" ) {
                    return;
                }

                // 比對密碼、確認密碼是否相符
                if(ValidatorUtil.isLengthMeet(this.inputPassword) && this.inputPassword!==this.inputConfirmPassword) {
                    this.confirmPasswordPromptString = this.$i18n.t('register.Validate.ConfirmPassword.notEqual');
                }
                else {
                    this.confirmPasswordPromptString = "";
                }
            }
        },
        async emailInputMonitor() {
            // 驗證email字串不為空，且符合格式
            this.emailPromptString = ValidatorUtil.validEmail(this.inputEmail, {
                'req': this.$i18n.t('register.Validate.Email.req'),
                'format': this.$i18n.t('register.Validate.Email.format'),
            })
        },
        checkPrivacyPolicyChecker() { // 會員條款及隱私條款
            if(!this.checkPrivacyPolicy.includes("1")) {
                this.checkPrivacyPolicyPromptString = this.$i18n.t('register.Validate.Terms.check');
            }
            else {
                this.checkPrivacyPolicyPromptString = "";
            }
        },
        checkPersonalPolicyChecker() { // 個資告知書
            if(!this.checkPersonalPolicy.includes("1")) {
                this.checkPersonalPolicyPromptString = this.$i18n.t('register.Validate.Terms.check');
            }
            else {
                this.checkPersonalPolicyPromptString = "";
            }
        },
        async googleRecaptchaService() {
            this.accountInputMonitor();
            this.passwordInputMonitor();
            this.confirmPasswordInputMonitor();
            this.emailInputMonitor();
            this.checkPrivacyPolicyChecker();
            this.checkPersonalPolicyChecker();
            if(this.accountPromptString != "" || this.passwordPromptString != "" || 
                this.confirmPasswordPromptString !="" || this.emailPromptString != "" ||
                this.checkPrivacyPolicyPromptString != "" || this.checkPersonalPolicyPromptString != "") {
                return; // 有錯誤訊息return
            }
            else {
                if(typeof grecaptcha !== 'undefined') {
                    RecaptchaUtil.startGoogleRecaptchaVerify(process.env.VUE_APP_AUTH_RECAPTCHA_REGISTER, this.registerService)
                }
            }
            return;
        },
        async registerService(gRecaptchaResponse) {
            this.domControl.isWaitingRegistratAll9fun = true
            const self = this;
            let bodyFormData = new FormData();
            bodyFormData.append("memberRegistration.consigneeCode", "@GT");
            bodyFormData.append("memberRegistration.account", this.inputAccount);
            bodyFormData.append("memberRegistration.password", this.inputPassword);
            bodyFormData.append("memberRegistration.confirmPassword", this.inputConfirmPassword);
            bodyFormData.append("memberRegistration.email", this.inputEmail);
            bodyFormData.append("checkPrivacyPolicy", (this.checkPrivacyPolicy.includes("1") ? "1" : "0"));
            bodyFormData.append("checkPersonalPolicy", (this.checkPersonalPolicy.includes("1") ? "1" : "0"));
            bodyFormData.append("g-recaptcha-response", gRecaptchaResponse);
            bodyFormData.append("mydomain", "all9fun.com");
            
            await axios({
                method: "post",
                timeout: process.env.VUE_APP_AJAX_TIME_OUT_MILLISECOND,
                url: process.env.VUE_APP_URL_DOMAIN_LOGIN + "/registratMemberJsonAction.shtml",
                data: bodyFormData,
                config: { headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }}
            })
            .then(function(response) {
                if(response.data.status == "success") { // 註冊成功
                    eventBus.$emit(process.env.VUE_APP_EVENT_EMIT_AUTO_LOGIN_WHEN_REGISTER_SUCCESS, response.data);
                    document.querySelector("#registerModal button").click();
                }
                else if(response.data.status == "failed") { // 驗證碼錯誤
                    alert(self.$i18n.t('register.Backend.Response.RecaptchaError'));
                }
                else if(response.data.status == "policy") { // 隱私條款或個資條款未勾選
                    alert(self.$i18n.t('register.Backend.Response.Policy'));
                }
                else if(response.data.status == "confirmpwd") { // 密碼與確認密碼不符
                    alert(self.$i18n.t('register.Backend.Response.PasswordNotEqual'));
                }
                else if(response.data.status == "duplicateAccount") { // 帳號重覆
                    alert(self.$i18n.t('register.Backend.Response.DuplicateAccount'));
                }
                else if(response.data.status == "duplicateEmail") { // 信箱重覆
                    alert(self.$i18n.t('register.Backend.Response.DuplicateEmail'));
                }
                else { // 包含未知錯誤{"status":"error"}
                    alert(self.$i18n.t('register.Backend.Response.Error'));
                }
            })
            .catch(function(response) {
                alert(self.$i18n.t('common.Backend.Response.ConnectionFailed'))
            })
            this.domControl.isWaitingRegistratAll9fun = false
        }
    },
}
</script>